/* Compact until opened, so the legend does not cover the activity list. */
#keys{bottom:16px;left:16px;padding:10px 15px;pointer-events:auto;font-size:.76rem}
#keys summary{cursor:pointer;color:var(--accent)}
#keys .key-grid{display:grid;grid-template-columns:auto 1fr;gap:7px 12px;
  align-items:center;margin-top:12px;max-height:65vh;overflow-y:auto}
#keys b{
  color:#171812;background:var(--accent);border:1px solid var(--accent);
  font-weight:500;white-space:nowrap;text-align:center;
  padding:3px 8px;border-radius:3px;font-size:.7rem;letter-spacing:.04em;
}
#keys span{color:var(--ink);opacity:.86}
@media (max-width:640px){
  #keys{display:none}
}
